// extracted by mini-css-extract-plugin
export default {"alert":"Success_alert__+cmzd"};